import { render, staticRenderFns } from "./ApmsBasicCanteenMaterialInfo.vue?vue&type=template&id=fb549b88&scoped=true&"
import script from "./ApmsBasicCanteenMaterialInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicCanteenMaterialInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb549b88",
  null
  
)

export default component.exports